import { Heading, Alert } from '@restworld/ui-ds-base';
import { EditButton } from './card-wrapper';
import { AcademicCapIcon, UserAcademicCapIcon, toDateFormat, useModal } from '@restworld/utils-common';
import { WorkerEducationEmbedded } from '@restworld/utility-types';
import { PresentationCard } from '@restworld/ui-components';
import { useMemo } from 'react';
import { ProfileEditModal } from './profile-edit';
import { animated, useSpring } from '@react-spring/web';
import { useProfileCommonIntl } from './hooks';

export const TrainingSectionItem = ({
  workerTraining,
  workerTrainingIndex,
}: {
  workerTraining: WorkerEducationEmbedded;
  workerTrainingIndex: number;
}) => {
  const { show: showModal, open: openModal, close: closeModal } = useModal();
  const memoValues = useMemo(() => {
    const title = workerTraining?.education_title_var.label;
    const issueDate = workerTraining?.issue_date ? toDateFormat(workerTraining?.issue_date) : undefined;
    return { title, issueDate };
  }, [workerTraining?.education_title_var.label, workerTraining?.issue_date]);
  const { title, issueDate } = memoValues;
  const isInformationMissing = !title || !issueDate;
  const { missingInfo: errorMessage, missingInfoText, translate: t } = useProfileCommonIntl();

  const viewContentStyles = useSpring({
    opacity: !showModal ? 1 : 0,
    transform: !showModal ? 'translateY(0%)' : 'translateY(5px)',
    config: { tension: 250, friction: 20 },
  });

  const editContentStyles = useSpring({
    opacity: showModal ? 1 : 0,
    transform: showModal ? 'translateY(0%)' : 'translateY(5px)',
    config: { tension: 250, friction: 20 },
  });

  return (
    <div className="flex flex-col w-full">
      {!showModal && (
        <div className="flex flex-row justify-between  items-center w-full mb-4">
          <Heading size={5} weight="medium">
            {t('common:training')} {workerTrainingIndex + 1}
          </Heading>
          <EditButton
            onClick={() => {
              openModal();
            }}
          />
        </div>
      )}
      {!showModal && (
        <animated.div style={viewContentStyles} className="flex lg:flex-row flex-col lg:gap-8 gap-4 w-full">
          {isInformationMissing && <Alert text={missingInfoText} className="mb-4" />}
          <div className="flex flex-col lg:w-1/2 w-full items-start justify-start gap-4">
            <PresentationCard
              label={t('common:qualification_1')}
              header={title || errorMessage}
              icon={<AcademicCapIcon />}
              isError={!title}
            />
          </div>
          <div className="flex flex-col lg:w-1/2 w-full items-start justify-start gap-4">
            <PresentationCard
              label={t('common:release_date')}
              header={issueDate || errorMessage}
              isError={!issueDate}
              icon={<UserAcademicCapIcon />}
            />
          </div>
        </animated.div>
      )}
      {showModal && (
        <animated.div style={editContentStyles} className="w-full">
          <ProfileEditModal
            showModal={showModal}
            onClose={closeModal}
            editPageType="education"
            mode="edit"
            editPageTitle={`${t('common:training')} ${workerTrainingIndex + 1}`}
            key={`formazione-${workerTrainingIndex + 1}`}
            editIndex={workerTrainingIndex}
          />
        </animated.div>
      )}
    </div>
  );
};
